import { Card, CardContent, CardHeader, Skeleton } from "@mui/material";
import React from "react";

export default function WebSiteCustomationShimmer() {
  return (
    <Card sx={{  m: 2 }}>
      <CardHeader
        title={
          <Skeleton
            animation="wave"
            height={10}
            width="100%"
            style={{ marginBottom: 6 }}
          />
        }
        subheader={<Skeleton animation="wave" height={10} width="100%" />}
      />
      <Skeleton sx={{ height: 130 }} animation="wave" variant="rectangular" />

      <CardContent>
        <React.Fragment>
          <Skeleton animation="wave" height={10} style={{ marginBottom: 6 }} />
          {/* <Skeleton animation="wave" height={10} width="80%" /> */}
        </React.Fragment>
      </CardContent>
    </Card>
  );
}
